import { EventEmitter } from 'events';

class WasmEventReceiver extends EventEmitter {}

let receiver: EventEmitter | null = null;

export function registerEventReceiver(cb: () => void) {
  if (receiver) {
    throw new Error('Has been registered.');
  }
  receiver = new WasmEventReceiver();
  window.onWasmEvent = evt => {
    console.log(evt);
    // 检查是否是文字编辑事件
    if (evt.startsWith('edit_text:')) {
      const elementId = evt.substring('edit_text:'.length);
      setTimeout(() => {
        receiver?.emit('edit_text', elementId);
      }, 0);
    } else {
      cb();
    }
  };
}

export function onTextEdit(callback: (elementId: string) => void) {
  if (!receiver) {
    throw new Error('Event receiver not registered.');
  }
  receiver.on('edit_text', callback);
  return () => {
    receiver?.off('edit_text', callback);
  };
}
